AFRAME.registerShader('superCutFxShader', {
  schema: {
    startTime: {type: 'float', is: 'uniform'},
    timeMs: {type: 'time', is: 'uniform'},
    color: {type: 'color', is: 'uniform'}
  },

  vertexShader: `
    varying vec2 uvs
    varying vec3 worldPos
    void main() {
      uvs.xy = uv.xy
      gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 )
    }
  `,

  fragmentShader: `
    uniform float startTime
    uniform float timeMs
    uniform vec3 color
    varying vec2 uvs
    varying vec3 worldPos

    void main() {
      float time = (timeMs - startTime) / 2000.0
      vec2 p = uvs.xy - 0.5
      float r = p.x * p.x + p.y * p.y
      float alpha = 1.0 - smoothstep(time - 0.01, time, r)
      alpha *= smoothstep(time - 0.1, time, r)
      alpha *= 1.0 - time * 5.5
      gl_FragColor = vec4(color, alpha)
    }
  `
});
if (module.hot && window.AFRAME) {
  const componentNames = [];

  const shaderNames = ['superCutFxShader',];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
